import React, { useEffect } from 'react';
import MetaData from '../MetaData';
import { Col, Container, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Loader from '../common/Loader';
import { Link, useNavigate } from 'react-router-dom';
import SectionHeading from '../common/SectionHeading';

const UserAccount = () => {
    const { user, loading, isAuthenticated } = useSelector((state) => state.user);
    const navigate = useNavigate();

    useEffect(() => {
        if (!isAuthenticated) {
            navigate('/login');
        }
    }, [isAuthenticated]);

    return loading ? (
        <Loader />
    ) : (
        <>
            <MetaData title={`${user?.name} - ShipShop`} />
            <Container>
                <div className='section-padding-top section-padding-bottom'>
                    <SectionHeading heading={'My Profile'} />
                    <Row className='align-items-center'>
                        <Col md={6} className='text-center'>
                            <div className='myAccountProfile mx-auto'>
                                <img src={user?.avatar?.url} alt={user?.name} />
                            </div>
                            <Link to='/me/update' className='secondary-btn d-inline-block mt-3'>
                                Edit Profile
                            </Link>
                        </Col>
                        <Col md={6} className='mt-md-0 mt-4'>
                            <div className='mb-4 pb-4 border-bottom'>
                                <div className='mb-3'>
                                    <b>Name: </b>
                                    <span className='ms-2 font-size-15'>{user?.name}</span>
                                </div>
                                <div className='mb-3'>
                                    <b>Email: </b>
                                    <span className='ms-2 font-size-15'>{user?.email}</span>
                                </div>
                                <div>
                                    <b>Joined On: </b>
                                    <span className='ms-2 font-size-15'>
                                        {user?.createdAt?.split('T')[0]}
                                    </span>
                                </div>
                            </div>
                            <Link to='/orders' className='primary-btn d-inline-block'>
                                My Orders
                            </Link>
                            <Link
                                to='/password/update'
                                className='secondary-btn d-inline-block ms-2'
                            >
                                Change Password
                            </Link>
                        </Col>
                    </Row>
                </div>
            </Container>
        </>
    );
};

export default UserAccount;
